import { AgentStatsDataAdapter } from 'common/data/agent/stats/data-adapter';

export function AgentStatsDataAdapterFactory(): AgentStatsDataAdapter {
  return new AgentStatsDataAdapter();
}
